import { render, staticRenderFns } from "./SalesOrderEdit.vue?vue&type=template&id=534b448c&scoped=true&"
import script from "./SalesOrderEdit.vue?vue&type=script&lang=js&"
export * from "./SalesOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderEdit.vue?vue&type=style&index=0&id=534b448c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b448c",
  null
  
)

export default component.exports